
import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';

import { Console } from 'console';
import { Mode } from 'src/app/enums/mode.enum';
import { OrderService } from 'src/app/services/order.service';
import { BillToService } from 'src/app/services/bill-to.service';
import { ModeService } from 'src/app/services/mode.service';
import { ConfigService } from 'src/app/services/config.service';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { OrderDto } from 'src/app/dtos/order-dto.model';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { ReferenceDto } from 'src/app/dtos/reference-dto.model';

@Component({
  selector: 'app-account-owner',
  templateUrl: './account-owner.component.html',
  styleUrls: ['./account-owner.component.css']
})
export class AccountOwnerComponent {
 Mode = Mode;
specialityLabel: string = 'Speciality:';
visibleTextValue = 'Refreshing Data';

accountOrderDto=new OrderDto();
accountmanageremail = '';
softwareExecEmail = '';
dataRepEmail = '';
printRepEmail = '';
printRepManagerEmail='';
accountSupervisorEmail='';
isAccountInfoLoading=false;
  editionYear = 0;
  accountManager = '';
  accountManagersupervisor='';
  datarep='';
  softwareexec='';
  
  print='';
  
  printrepManager='';
  configIsReadySubscription?: Subscription;
  orderIsReadySubscription?: Subscription;

  @Input() isnavigateFromBatchReturn: boolean = false;

  constructor(
    public readonly orderService: OrderService,
    public readonly billToService: BillToService,
    private readonly configService: ConfigService,
    public readonly modeService: ModeService,
    private readonly cdr: ChangeDetectorRef
  ) {}
  
ngOnInit(): void {

  this.orderIsReadySubscription =
    this.orderService.orderIsReady.subscribe(order => {

      console.log("ORDER RECEIVED:", order);

      if (!order) return;

      this.isAccountInfoLoading = true;

      setTimeout(() => {
        this.setAccountManager(order);
        
      });
      this.isAccountInfoLoading = false;
    });
}

  ngOnDestroy(): void {
    this.configIsReadySubscription?.unsubscribe();
    this.orderIsReadySubscription?.unsubscribe();
  }
refreshAccountTo() {
  const orderId = this.orderService.orderDto?.id;
  if (!orderId) return;

  this.isAccountInfoLoading = true;

  // Only clear reference cache
  this.configService.clearReferenceCache();

  // Reload references only
  this.configService.getReferences().pipe(
    switchMap(() => this.orderService.getOrderInfo(orderId)),
    tap((order) => {
      this.accountOrderDto = { ...order };
      this.setAccountManager(this.accountOrderDto);
    }),
    finalize(() => {
      this.isAccountInfoLoading = false;
      this.cdr.markForCheck();
    })
  ).subscribe();
}

setAccountManager(orderDto: OrderDto) {
  const billTo = orderDto?.billToDto;
  if (!billTo) return;

  // Account Manager
  this.setContactFromCode(
    billTo.accountOwnerCode,
    (name) => (this.accountManager = name),
    (email) => (this.accountmanageremail = email)
  );

  // Print Rep
  this.setContactFromCode(
    billTo.printRepCode,
    (name) => (this.print = name),
    (email) => (this.printRepEmail = email)
  );

  // Print Rep Manager
  this.setSupervisorFromUserCode(
    billTo.printRepCode,
    (name) => (this.printrepManager = name),
    (email) => (this.printRepManagerEmail = email)
  );

  // Software Executive
  this.setContactFromCode(
    billTo.softwareExecutiveCode,
    (name) => (this.softwareexec = name),
    (email) => (this.softwareExecEmail = email)
  );

  // Data Rep
  this.setContactFromCode(
    billTo.dataFileRepCode,
    (name) => (this.datarep = name),
    (email) => (this.dataRepEmail = email)
  );

  // Account Owner Supervisor
  this.setSupervisorFromUserCode(
    billTo.accountOwnerCode,
    (name) => (this.accountManagersupervisor = name),
    (email) => (this.accountSupervisorEmail = email)
  );
}

/**
 * Sets name and email for a given user code using configService.
 * Safely no-ops if the code is falsy or lookups return falsy.
 */
private setContactFromCode(
  userCode: string | undefined | null,
  setName: (name: string) => void,
  setEmail: (email: string) => void
): void {
  if (!userCode) return;

  const name = this.configService.getFullNameFromUserCode(userCode);
  if (name) setName(name);

  const email = this.configService.getUserEmailFromUserCode(userCode);
  if (email) setEmail(email);
}

/**
 * Resolves the supervisor for a user code and then sets name/email via setContactFromCode.
 */
private setSupervisorFromUserCode(
  userCode: string | undefined | null,
  setName: (name: string) => void,
  setEmail: (email: string) => void
): void {
  if (!userCode) return;

  const supervisorCode = this.configService.getUserSupervisorFromUserCode(userCode);
  if (!supervisorCode) return;

  this.setContactFromCode(supervisorCode, setName, setEmail);
}
}
